import { useReviewData } from "@components/QaReview/hooks/useReviewData";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

export const useCloseThreadDrafts = () => {
  const { state, dispatch } = useReviewSession();
  const { repliesByParentId } = useReviewData();

  return (rootId: string) => {
    if (state.composer?.kind === "reply" && state.composer.parentId === rootId) dispatch({ type: "closeComposer" });

    const { editingCommentId } = state;
    const editingInThread =
      editingCommentId === rootId || !!repliesByParentId.get(rootId)?.some((reply) => reply.id === editingCommentId);
    if (editingCommentId && editingInThread) dispatch({ type: "stopEditing" });
  };
};
